import CreateEditExceptionalClosedDays from "@/components/createEditExceptionalClosedDays/createEditExceptionalClosedDays.vue";
import ConfirmChangeDatesModal from "@/components/modal/confirmChangeDatesModal.vue";
import { createNamespacedHelpers } from "vuex";

const { mapActions: userActions } = createNamespacedHelpers("user");

export default {
	components: {
		CreateEditExceptionalClosedDays,
		ConfirmChangeDatesModal,
	},

	props: {
		date: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			isEdit: false,
			showDeletePrompt: false,
		};
	},

	methods: {
		onConfirmDelete,

		...userActions(["deleteExceptionalClosedDay"]),
	},
};

function onConfirmDelete() {
	this.deleteExceptionalClosedDay(this.date);
}
